import Head from 'next/head';
import RegisterPage from '../../components/pages/Register/register';
import { withPublicOnlyRoute } from '../../lib/auth/publicOnlyRoute';
import { withSessionSsr } from '../../lib/withSession';

export default function Register() {
  return (
    <>
      <Head>
        <title>Dealer Portal - Register</title>
      </Head>
      <RegisterPage />
    </>
  );
}

export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {
    return withPublicOnlyRoute(ctx, (ctx) => {
      return {
        props: {},
      };
    });
  }
);
